export enum Trend {
  up = 'up',
  down = 'down',
}

export type RawScoreDataPoint = {
  ayble_score?: number;
  cd_score?: number;
  created_at: string;
  ibs_score?: number;
  id: string;
  modified_at: string;
  score_date: string;
  stress_score?: number;
  uc_score?: number;
  user_id: string;
  upper_gi_score?: number;
};
